import { Slot } from '@@types'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'


interface SlotState {
  selectedSlot: Slot | null;
  setSelectedSlot: (slot: Slot) => void;
  clearSelectedSlot: () => void;
  isActiveSlot: (id: string | null | undefined) => boolean;
}

export const useSlotStore = create(
  persist<SlotState>(
    (set, get) => ({
      selectedSlot: null,

      setSelectedSlot: (slot) => set({ selectedSlot: slot }),
      clearSelectedSlot: () => set({ selectedSlot: null }),

      isActiveSlot: (id) => {
        const currentId = get().selectedSlot?.id
        return Boolean(id && currentId && id === currentId)
      },
    }),
    {
      name: 'selected-slot',
    },
  ),
)
